import { ArrayHelpers, SystemText } from 'e4shared';
import { ratingColour } from 'helpers/metrics';
import React from 'react';

export const PositiveIndicators = ({ positiveIndicators, hideColour }) => {
    const hasUser = positiveIndicators?.some(pi => pi.userRated);
    const hasManager = positiveIndicators?.some(pi => pi.managerRated);

    const noRating = <label className="label label-grey">?</label>;

    return ArrayHelpers.existsAndHasLength(positiveIndicators) ? (
        <table className="table mt10">
            <thead>
                <tr>
                    <th className="bold">{SystemText('General/Controls/PositiveIndicators/Heading')}</th>
                    {hasManager && (
                        <th className="text-center no-wrap">
                            <i className="fa fa-user-tie-hair" />
                        </th>
                    )}
                    {hasUser && (
                        <th className="text-center no-wrap">
                            <i className="fa fa-user" />
                        </th>
                    )}
                    {!hasUser && !hasManager && (
                        <th className="text-center no-wrap">
                            <i className="fa fa-user" />
                        </th>
                    )}
                </tr>
            </thead>
            <tbody>
                {positiveIndicators.map(pi => (
                    <tr key={`positive-idicator-${pi.id}`}>
                        <td style={{ maxWidth: '500px' }}>
                            <div className="flex">
                                <i className="fa fa-check-square text-success mr10" style={{ marginTop: '3px' }} />
                                {pi.statement}
                            </div>
                        </td>
                        {hasManager && (
                            <td className="text-center">
                                {pi.managerRated ? (
                                    <label
                                        className={`label label-${hideColour ? 'default' : ratingColour(pi.managerRated)}`}
                                    >
                                        {pi.managerRated}
                                    </label>
                                ) : (
                                    noRating
                                )}
                            </td>
                        )}
                        {hasUser && (
                            <td className="text-center">
                                {pi.userRated ? (
                                    <label className={`label label-${hideColour ? 'default' : ratingColour(pi.userRated)}`}>
                                        {pi.userRated}
                                    </label>
                                ) : (
                                    noRating
                                )}
                            </td>
                        )}
                        {!hasUser && !hasManager && <td className="text-center">{noRating}</td>}
                    </tr>
                ))}
            </tbody>
        </table>
    ) : null;
};

export default PositiveIndicators;
